import { loginByUsername, logout, getMyRoles } from '@/api/login'
import { getAdminUser } from '@/api/site'
import { getToken, setToken, removeToken, setUserInfo, getUserInfo, removeUserInfo, setRoles,
  removeRoles } from '@/utils/auth'
import store from '@/store'
import router from '@/router'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password).then(response => {
          const data = response.data
          if (data.session && data.session.id) {
            commit('SET_TOKEN', data.session.id)
            setToken(data.session.id)
            setUserInfo(data.user)
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getMyRoles().then(response => {
          // 由于mockjs 不支持自定义状态码只能这样hack
          // if (response.data) {
          //   reject('Verification failed, please login again.')
          // }
          // debugger
          const data = response.data
          const codes = data.role.codes
          let roles = [];
          if(codes&& codes.indexOf(',')>-1) {
            roles = codes.split(',')
          }
          // roles = ['sys', 'sys-setting', 'sys-admin', 'sys-role', 'sys-fee', 'sys-protocol', 'sys-school',
          //   'sys-protocol-edit', 'user', 'user-list', 'user-player', 'user-player-edit', 'user-coach',
          //   'user-coach-edit', 'user-inReferee', 'user-inReferee-edit', 'user-outReferee', 'user-outReferee-edit',
          //   'user-club', 'user-club-edit', 'user-club-apply', 'league', 'league-list', 'league-edit', 'league-referee',
          //   'league-group', 'league-group-edit', 'league-group-team', 'league-group-team-player', 'league-group-game',
          //   'league-group-game-score', 'league-group-game-edit', 'league-team', 'league-game', 'stats-export', 'out-league-list', 'referee-stats', 'referee-stats-edit']
          if (roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', roles)
          } else {
            // reject('getMyRoles: roles must be a non-null array!')
            reject('该用户权限为空!')
          }

          // commit('SET_NAME', data.name)
          // commit('SET_AVATAR', data.avatar)
          resolve(roles)
        }).catch(error => {
          reject(error)
        })

        //实时获取用户信息
        const userInfo = getUserInfo()
        getAdminUser(userInfo.id).then(response => {
          const data = response.data
          if(data.admin) {
            commit('SET_NAME', data.admin.trueName)
            commit('SET_AVATAR', data.admin.profile)
          }
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          removeRoles()
          removeUserInfo()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
